
// Shared invalidation rule for WHOLE-FEATURE parametric shapes (Cirkel,
// Rektangel - task DEL E) - as opposed to arcRangeStore.js's per-RANGE
// metadata (an arc only ever owns a sub-interval of a larger LineString), a
// Circle/Rectangle feature's parametric definition always owns EVERY vertex
// of its own feature, so there is no index-range/reindexing concept to
// track here at all - just "did the geometry change at all since the shape
// was last (re)asserted". No DOM/THREE dependency - plain coordinate
// arrays, Level 1 (no-browser) unit testable.
//
// Storage location: `feature.domainData.circle` / `feature.domainData.rectangle`
// (same `domainData` extensibility point arcRangeStore.js's own header
// comment documents for the arc). Shape:
//   circle:    {type:"circle", center:[x,y,z], radiusM, u:[x,y,z], v:[x,y,z]}
//   rectangle: {type:"rectangle", anchor:[x,y,z], u:[x,y,z], v:[x,y,z], lengthM, widthM}
//
// `PARAMETRIC_SHAPE_NAMESPACES` lists every namespace this rule applies to -
// DigitizationModule.js's geometry_changed listener loops over exactly this
// list, so adding a future whole-feature parametric shape means adding one
// entry here, not touching the lifecycle wiring itself.
export const PARAMETRIC_SHAPE_NAMESPACES = ["circle", "rectangle"];

const COORD_EPS = 1e-9;

function samePosition(o, n){
	return Math.abs(o[0] - n[0]) < COORD_EPS && Math.abs(o[1] - n[1]) < COORD_EPS && Math.abs(o[2] - n[2]) < COORD_EPS;
}

// True if the shape should SURVIVE this geometry change (every vertex
// position identical, same vertex count) - false if it should be dissolved
// (task: "Hvis brugeren manuelt redigerer vertices på en måde, der bryder
// den parametriske form: opløs shape-definitionen, behold brugerens
// aktuelle geometri" - dissolving here only ever means clearing the
// metadata; the caller is responsible for NOT touching the coordinates
// themselves). `oldCoords`/`newCoords` are plain [[x,y,z],...] arrays (the
// same shape as feature.geometry.coordinates), matching arcRangeStore.js's
// reconcileArcRanges() convention so both can be called side by side from
// the same geometry_changed listener with the same two arrays.
//
// The shape-editing dialog itself (live preview and commit alike) re-
// asserts its own metadata via featureManager.setDomainData() immediately
// after every one of its own setPoints() calls - exactly the same pattern
// arcFromSagitta's editing dialog already uses to avoid self-dissolving the
// very shape it is actively editing, without needing a suppression flag
// here (see openArcDialog()'s own doc comment in VectorEditingMenu.js).
export function parametricShapeSurvives(oldCoords, newCoords){
	if(oldCoords.length !== newCoords.length) return false;
	for(let i = 0; i < oldCoords.length; i++){
		if(!samePosition(oldCoords[i], newCoords[i])) return false;
	}
	return true;
}
